import DescriptionIcon from '@mui/icons-material/Description';
import LaunchIcon from '@mui/icons-material/Launch';
import MailIcon from '@mui/icons-material/Mail';
import { Box, Paper, Stack, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import type { TimelineItemData } from '../../../types/folder-label';
import { FolderChip } from '../../atoms/folder-label/FolderChip';

const useStyles = makeStyles(() => ({
    card: {
        backgroundColor: '#ffffff',
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        padding: '16px',
        transition: 'border-color 0.2s',
        '&:hover': {
            borderColor: '#5eead4',
        },
    },
    icon: {
        color: '#9ca3af',
        marginTop: '2px',
    },
    iconLink: {
        color: '#3b82f6',
        marginTop: '2px',
    },
    title: {
        fontWeight: 600,
        color: '#1f2937',
    },
    from: {
        fontSize: '14px',
        color: '#4b5563',
    },
    preview: {
        fontSize: '12px',
        color: '#6b7280',
        marginTop: '4px',
    },
    link: {
        fontSize: '12px',
        color: '#2563eb',
        marginTop: '4px',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
}));

interface TimelineItemCardProps {
    item: TimelineItemData;
    type: 'email' | 'file';
}

export const TimelineItemCard: React.FC<TimelineItemCardProps> = ({ item, type }) => {
    const classes = useStyles();

    const renderIcon = () => {
        if (type === 'email') {
            return <MailIcon className={classes.icon} fontSize="small" />;
        }
        if (item.isLink) {
            return <LaunchIcon className={classes.iconLink} fontSize="small" />;
        }
        return <DescriptionIcon className={classes.icon} fontSize="small" />;
    };

    return (
        <Paper className={classes.card} elevation={0}>
            <Stack direction="row" spacing={1.5}>
                {renderIcon()}
                <Box flex={1}>
                    <Typography className={classes.title} mb={1}>
                        {item.title}
                    </Typography>
                    <Box mb={1}>
                        <FolderChip label={item.folder} />
                    </Box>
                    {item.from && (
                        <Typography className={classes.from}>From: {item.from}</Typography>
                    )}
                    {item.preview && (
                        <Typography className={classes.preview}>{item.preview}</Typography>
                    )}
                    {item.isLink && item.link && (
                        <Typography component="a" href={item.link} className={classes.link}>
                            {item.link}
                        </Typography>
                    )}
                </Box>
            </Stack>
        </Paper>
    );
};
